<template>
  <div class="page-not-found">
    <img
      v-if="logoUrl"
      :src="logoUrl"
      class="img-logo-header img-responsive"
      :alt="appShortName"
      width="250"
    />
    <img
      v-else
      src="~@/assets/img/logoDPC.svg"
      class="img-logo-header img-responsive"
      :alt="appShortName"
      width="250"
    />

    <br />
    <h2>Loja em manutenção</h2>
    <p style="text-align: center">
      Estamos em manutenção para melhorar sua experiência de compra. <br />
      Pedimos desculpas por qualquer inconveniência. Voltaremos em breve.
    </p>

    <div class="maintenance-code">
      <div v-if="showTokenInput" class="form-group col-md-12">
        <input
          v-model="maintenanceToken"
          type="text"
          class="form-control input-search searchbox__input"
          placeholder="Código de acesso"
          autocomplete="off"
          @keyup.enter="saveToken()"
        />
      </div>

      <a
        v-if="!showTokenInput"
        href="javascript:void(0)"
        @click="showTokenInput = !showTokenInput"
        >Possui um código?</a
      >
      <a v-else href="javascript:void(0)" @click="saveToken()">Entrar</a>
    </div>
  </div>
</template>

<script>
export default {
  name: "NotFound",
  metaInfo: {
    title: "Manutenção",
    titleTemplate: "Manutenção",
    meta: [],
  },
  components: {},
  data() {
    return {
      logoUrl: process.env.VUE_APP_LOGO_URL,
      appShortName: process.env.VUE_APP_NAME_SHORT,
      timer: null,
      maintenanceToken: "",
      showTokenInput: false,
    };
  },
  mounted() {
    window.addEventListener("focus", this.startTimer);
    window.addEventListener("blur", this.stopTimer);
    this.startTimer();

    this.$store.dispatch("setClearLoadingModal");
  },
  beforeDestroy() {
    window.removeEventListener("focus", this.startTimer);
    window.removeEventListener("blur", this.stopTimer);
    this.stopTimer();
  },
  methods: {
    saveToken() {
      localStorage.setItem("maintenance_secret", this.maintenanceToken);
      window.location.replace("/");
    },
    async fetchData() {
      try {
        const url = `${process.env.VUE_APP_APIB2B}/v1/maintenance/status`;
        const { data } = await dpcAxios.connection().get(url);
        if (!data.maintenance) {
          window.location.replace(this.$route.query.redirect);
        }
      } catch (e) {
        console.error(e);
      }
    },
    startTimer() {
      this.fetchData();

      this.timer = setInterval(() => {
        this.fetchData();
      }, 60000);
    },
    stopTimer() {
      clearInterval(this.timer);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/css/sass/bootstrap/variables";

.page-not-found {
  display: flex;
  padding: 30px 0;
  align-items: center;
  flex-direction: column;
  background: var(--brand-primary, $brand-primary) !important;
  position: fixed !important;
  width: 100% !important;
  height: 100% !important;
  top: 0;
  left: 0;
  margin-top: 0 !important;
  justify-content: center;
  min-height: 0 !important;
  color: white;
  z-index: 999999;

  // mobile
  @media (max-width: 800px) {
    padding: 0 15px;
    text-align: center;
  }

  img {
    padding: 15px;
  }
  .pnf-404 {
    font-size: 80px;
  }

  .pnf-btn {
    margin: 10px 0;
  }

  .maintenance-code {
    position: absolute;
    right: 10px;

    top: 10px;

    display: flex;
    flex-direction: column;
    width: 300px;
    text-align: right;

    color: white;
    opacity: 0.2;

    a:hover {
      color: var(--brand-accent, $brand-accent);
    }
  }
}
</style>
